/* eslint-disable no-useless-escape */
/* eslint-disable no-lonely-if */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-shadow */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-debugger */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-mixed-operators */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React, { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { Link } from 'react-router-dom';
import Toggle from 'react-toggle';
import { DebounceInput } from 'react-debounce-input';
import CategoryToolTip from '../../../Components/CategoryToolTip';
import { PriceHandler } from '../../../redux/helper/CamelCase';
import { ExpectedDateGenerator } from '../../../redux/helper/DateConverter';
import { CDN } from '../../../constants';
import { distributorService } from '../../../service/distributor.service';
import DeleteProductsModal from './Modals/DeleteProductsModal';
import ItemPriceTooltip from '../../../Components/ItemPriceTooltip';

export default function ProductCard({
    prod, OrderDetails,
    setOrderDetails,
    addressDropdown,
    groupIdx,
    UserRole,
    handleFetch,
    itemIndex,
    ThreelPl,
}) {
    const [TypeToggle, setTypeToggle] = useState(prod?.trade_discount_type === '₹' ? '₹' : '%');
    const [discount, setdiscount] = useState(prod.trade_discount);
    const handleImage = (img) => (img ? `${CDN}/product-images/${img}` : '/images/gen.png');
    const [hoverId, sethoverId] = useState('');
    const [isOn, setIsOn] = useState(false);
    const [totalPricehoverId, setTotalitemPricehoverId] = useState('');
    const [subTotalPricehoverId, setSubTotalPricehoverId] = useState('');
    const [addressType, setaddressType] = useState({
        shipping_address: false,
        billing_address: false,
    });
    const [deleteModal, setDeleteModal] = useState(false);
    const [searchKey, setsearchKey] = useState('');

    const toggleSwitch = async () => {
        if (isOn !== true) {
            const { items, instruction } = OrderDetails;
            const category = groupIdx;
            items[category].map((item, index) => {
                items[category][index].SHIPPING_ADDRESS = prod.SHIPPING_ADDRESS;
                items[category][index].BILLING_ADDRESS = prod.BILLING_ADDRESS;
            });
            const res = await distributorService.OrderStatusUpdate({ items }, OrderDetails.distributor_id, OrderDetails.order_number);
            if (!res.error && res.data.success_status) {
                handleFetch();
            } else {
                // console.log(res?.message?.response?.data?.message);
            }
        }
        setIsOn(!isOn);
    };

    const handleClose = () => {
        setaddressType({
            shipping_address: false,
            billing_address: false,
        });
    };
    const handleToggle = (key) => {
        handleClose();
        setaddressType((prev) => ({
            ...prev,
            [key]: !addressType[key],

        }));
    };

    const handlePrice = async (val, type) => {
        if (val !== '' && val > -1 && Number(val) < Number(prod.sub_total)) {
            const { items, instruction } = OrderDetails;
            const category = groupIdx;
            let updateItem = {};
            const index = items[category].findIndex((p) => p.item_id === prod.item_id);
            if (index >= 0) {
                items[category][index].trade_discount_type = type;
                items[category][index].trade_discount = val;
                updateItem = items[category][index];
            }
            const res = await distributorService.OrderStatusUpdate({ items }, OrderDetails.distributor_id, OrderDetails.order_number);
            if (!res.error && res.data.success_status) {
                handleFetch();
            } else {
                // console.log(res?.message?.response?.data?.message);
            }
        }
    };

    const handleAddress = async (val, type) => {
        const { items, instruction } = OrderDetails;
        const category = groupIdx;
        const index = items[category].findIndex((p) => p.item_id === prod.item_id);
        if (index >= 0) {
            items[category][index][type.toUpperCase()] = val;
        }
        const res = await distributorService.OrderStatusUpdate({ items }, OrderDetails.distributor_id, OrderDetails.order_number);
        if (!res.error && res.data.success_status) {
            handleFetch();
        } else {
            // console.log(res?.message?.response?.data?.message);
        }
        handleToggle(type);
    };

    const handleThreepl = async (val) => {
        const { items, instruction } = OrderDetails;
        const category = groupIdx;
        const index = items[category].findIndex((p) => p.item_id === prod.item_id);
        const threeplindex = ThreelPl.findIndex((p) => p.DESCRIPTION === val);
        if (index >= 0) {
            items[category][index]['3pl'] = ThreelPl[threeplindex];
        }
        const res = await distributorService.OrderStatusUpdate({ items }, OrderDetails.distributor_id, OrderDetails.order_number);
        if (!res.error && res.data.success_status) {
            handleFetch();
        } else {
            // console.log(res?.message?.response?.data?.message);
        }
    };

    const [quantityError, setquantityError] = useState(false);
    const [quantity, setquantity] = useState(prod?.quantity);

    const handleConfirm = async (quantity) => {
        const { items, instruction } = OrderDetails;
        const category = groupIdx;
        const index = items[category].findIndex((p) => p.item_id === prod.item_id);
        if (index >= 0) {
            items[category][index].quantity = quantity;
        }
        const res = await distributorService.OrderStatusUpdate({ items }, OrderDetails.distributor_id, OrderDetails.order_number);
        if (!res.error && res.data.success_status) {
            handleFetch();
            setquantityError(false);
        } else {
            // console.log(res?.message?.response?.data?.message);
        }
    };
    const handleCheck = (copy) => {
        setquantityError(false);
        if (!prod?.PRIMARY_UOM_CODE?.toLowerCase().includes('b')) {
            if ((Math.round(copy * 10000) % Math.round((prod?.PACKING_SIZE || 1) * 10000) !== 0)) {
                setquantityError(true);
            } else {
                handleConfirm(copy);
            }
        } else {
            if (copy < 1) {
                setquantityError(true);
            } else {
                handleConfirm(copy);
            }
        }
    };

    function AddressSelection({
        selectedAddressObj, index, type, selection,
    }) {
        return (
            <label onClick={() => { if (selection === true) handleAddress(selectedAddressObj, type); }} htmlFor={`${`checkbox-address-${itemIndex}-${type}-${index}`}`} className="text-sm font-normal text-[#555259] pl-2 cursor-pointer mt-[3px] text-left">
                <p>
                    {selectedAddressObj?.ADDRESS1}
                    ,
                </p>
                <p>
                    {selectedAddressObj?.ADDRESS2}
                    ,
                    {selectedAddressObj?.ADDRESS3}
                </p>
                <p>
                    {`${selectedAddressObj?.CITY}`}
                    -
                    {`${selectedAddressObj?.POSTAL_CODE}`}
                    ,
                    {`${selectedAddressObj?.STATE}`}
                    {' '}
                    Location :
                    {' '}
                    {`${selectedAddressObj?.LOCATION}`}
                    {' '}
                </p>
                <p>
                    GSTIN :
                    {' '}
                    {`${selectedAddressObj?.ATTRIBUTE2}`}
                </p>
            </label>
        );
    }

    const handleSearch = (val) => {
        if (searchKey === '') {
            return val;
        } if (val.ADDRESS1?.toLowerCase().includes(searchKey.toLowerCase())
        || val.ADDRESS2?.toLowerCase().includes(searchKey.toLowerCase())
        || val.ADDRESS3?.toLowerCase().includes(searchKey.toLowerCase())
        || val.ADDRESS4?.toLowerCase().includes(searchKey.toLowerCase())
        || val.POSTAL_CODE?.toLowerCase().includes(searchKey.toLowerCase())
        || val.LOCATION?.toLowerCase().includes(searchKey.toLowerCase())) {
            return val;
        }
    };

    function nearest(n, x) {
        const u = n % x >= x / 2;
        return n + (-1) ** (1 - u) * Math.abs(x * u - n % x);
    }
    const handleQuantity = (type, quantity) => {
        let copy = Number(quantity);
        if (type === '+') {
            copy = nearest(copy, ((prod?.PRIMARY_UOM_CODE?.toLowerCase().includes('b') ? 1 : Number(prod?.PACKING_SIZE) || 1)));
            if (Number(quantity) === (Number(copy))) {
                copy += (prod?.PRIMARY_UOM_CODE?.toLowerCase().includes('b') ? 1 : Number(prod.PACKING_SIZE) || 1);
            }
            if (!Number.isInteger(quantity)) {
                copy = copy.toFixed(2);
                setquantity(copy);
            } else {
                setquantity(copy);
            }
        }
        if (type === '-') {
            if (copy - (prod?.PRIMARY_UOM_CODE?.toLowerCase().includes('b') ? 1 : prod.PACKING_SIZE) >= (prod?.PRIMARY_UOM_CODE?.toLowerCase().includes('b') ? 1 : prod?.MINIMUM_ORDER_QUANTITY)) {
                if (Math.abs(copy % Number(prod?.PACKING_SIZE) || 1) < 0.0001) {
                    copy = nearest(copy, ((prod?.PRIMARY_UOM_CODE?.toLowerCase().includes('b') ? 1 : Number(prod?.PACKING_SIZE) || 1)));
                } else copy -= (prod?.PRIMARY_UOM_CODE?.toLowerCase().includes('b') ? 1 : Number(prod.PACKING_SIZE) || 1);
                if (!Number.isInteger(quantity)) {
                    copy = copy.toFixed(2);
                    setquantity(copy);
                } else {
                    setquantity(copy);
                }
            }
        }
        handleCheck(copy);
    };

    const handleTypeToggle = (type) => {
        setTypeToggle(type);
        if (type === '%' && Number(discount) > 99.99) {
            setdiscount(0, type);
            handlePrice(0, type);
        } else {
            handlePrice(discount, type);
        }
        if (type === '%') {
            setdiscount(0);
        }
    };

    const calculateTotalPriceNetDiscount = () => {
        if (!prod?.LIST_PRICE || Number(prod?.LIST_PRICE) === 0 || !prod?.quantity || Number(prod?.quantity) === 0) return null;
        const totalListPrice = Number(prod?.LIST_PRICE) * Number(prod?.quantity);
        const netDiscount = ((totalListPrice - Number(prod?.total_price)) / totalListPrice) * 100;
        return netDiscount;
    };
    const totalPriceNetDiscount = calculateTotalPriceNetDiscount();

    const handleDeleteProduct = async () => {
        const { items, instruction } = OrderDetails;
        const category = groupIdx;
        const index = items[category].findIndex((p) => p.item_id === prod.item_id);
        if (index >= 0) {
            items[category].splice(index, 1);
        }
        const res = await distributorService.OrderStatusUpdate({ items }, OrderDetails.distributor_id, OrderDetails.order_number);
        if (!res.error && res.data.success_status) {
            handleFetch();
            setquantityError(false);
            setDeleteModal(false);
        } else {
            // console.log(res?.message?.response?.data?.message);
        }
    };

    return (
        <div className="rounded-lg bg-[#FFFFFF] shadow-s7 px-4 pb-0 pt-4 relative mt-2 mb-1.5">
            <div className="flex flex-wrap">
                <div className="w-full pt-2">
                    <div className="flex pt-4">
                        <div className="sm:w-1/4 w-[20%]">
                            <motion.img
                                initial={{ opacity: 0, scale: 0.6 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{
                                    duration: 0.8,
                                    delay: 0.5,
                                    ease: [0, 0.71, 0.2, 1.01],
                                }}
                                src={handleImage(prod?.IMAGE_NAME)}
                                alt="icon"
                                className="w-full"
                            />
                        </div>
                        <div className="pl-2.5 sm:w-full">
                            <div className="flex justify-between items-center">
                                <div className="flex sm:items-center items-start sm:flex-row flex-col">
                                    <p className="sm:text-xl text-base font-bold text-[#090406] pr-3">{prod?.MODEL_DESCRIPTION?.slice(0, 20) || `${prod?.DESCRIPTION.length > 10 ? `${prod.DESCRIPTION.slice(0, 10)}...` : `${prod.DESCRIPTION}`}`}</p>
                                    <p className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit sm:mt-0 mt-1">{prod?.MAIN_CATEGORY}</p>
                                </div>
                                <div className="flex items-center">
                                    <p className="text-xs font-normal text-[#777777]">3PL Location</p>
                                    <select
                                        onChange={(e) => handleThreepl(e.target.value)}
                                        className="h-7 w-full rounded-lg outline-0 border bg-[#F5F5FA] border-[#B1B4B7] bg-[#FFFFFF] font-semi-bold text-base text-[#555259] px-3.5"
                                    >
                                        {ThreelPl && ThreelPl.map((item, threeindex) => (
                                            <option
                                                key={threeindex}
                                                value={item.DESCRIPTION}
                                                selected={item.DESCRIPTION === prod['3pl'].DESCRIPTION}
                                            >
                                                {item.DESCRIPTION}

                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="flex justify-between items-center w-full">
                                <div className="w-[70%]">
                                    <p className="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1">
                                        <span>
                                            Product Code:
                                            {' '}
                                            {prod?.CONCATENATED_SEGMENTS}
                                        </span>
                                        <span className="sm:px-4 px-2">|</span>
                                        <span>
                                            AWS Classification:
                                            {' '}
                                            {prod?.AWS_CLASSIFICATION}
                                        </span>
                                    </p>
                                </div>
                                <div className="xl:w-[25%] w-full pt-0 relative">
                                    <div className="flex justify-end w-full xl:pr-[30px] pr-0 xl:mt-0 mt-3">
                                        <p className="sm:text-xs6 text-xs2 font-normal text-[#808285] bg-[#F5F5FA] rounded-[3px] px-2.5 py-[7px] w-fit xl:mb-0 mb-3">
                                            Stock:
                                            {' '}
                                            <span className="text-[#424446] font-semibold">
                                                <span className="text-[#424446] font-semibold">
                                                    {prod?.STOCK_ONHAND_QTY}
                                                    {' '}
                                                    {prod?.PRIMARY_UOM_CODE}
                                                </span>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-2 flex sm:items-center items-baseline sm:flex-row flex-col">
                                <div className="flex sm:border-r sm:border-[#707070] sm:pr-[6px] w-fit items-center">
                                    <p className="text-xs font-semibold text-[090406]">Category</p>
                                    <p className="text-xs3 font-semibold text-white px-1 bg-[#555259] rounded-[3px] w-fit mx-1.5">A</p>
                                    <button data-tooltip-target="tooltip-information" data-tooltip-placement="left" data-tooltip-trigger="click" type="button">
                                        <img
                                            src="/images/info_icon.svg"
                                            alt="icon"
                                            className="cursor-pointer h-[15px]"
                                            onMouseEnter={() => {
                                                setTimeout(() => {
                                                    sethoverId(prod.INVENTORY_ITEM_ID);
                                                }, 1000);
                                            }}
                                            onMouseLeave={() => {
                                                setTimeout(() => {
                                                    sethoverId('');
                                                }, 2000);
                                            }}
                                        />
                                    </button>
                                    {hoverId === prod.INVENTORY_ITEM_ID && (
                                        <CategoryToolTip hover={hoverId === prod.INVENTORY_ITEM_ID} />
                                    )}
                                </div>
                                <p className="text-xs font-semibold text-[#808285] sm:px-[6px] sm:border-r sm:border-[#707070] sm:pt-0 pt-1">
                                    Expected Dispatch:
                                    {' '}
                                    <span className="font-bold text-[#555259]">{prod.DELIVERY_LEAD_TIME ? ExpectedDateGenerator(prod?.DELIVERY_LEAD_TIME) : '-'}</span>
                                </p>

                                <p className="text-xs3 font-semibold text-[#808285] sm:pl-[6px] sm:pt-0 pt-1">
                                    Method of Packing:
                                    {' '}
                                    <span className="font-bold text-[#555259]">{prod?.METHOD_OF_PACKING}</span>
                                </p>
                            </div>
                            <p className="font-normal text-xs text-[#808285] mt-2.5">{prod?.DESCRIPTION}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className="py-2  mt-2  w-full flex items-center flex-wrap lg:px-4 px-0">
                    <div className="flex items-center w-full justify-between">
                        <div>
                            <p className="text-xs3 font-semibold text-[#808285]">List Price</p>
                            <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">{PriceHandler(prod?.LIST_PRICE)}</p>
                        </div>
                        <div className="max-w-[50%]">
                            <p className="text-xs3 font-semibold text-[#808285] mb-2 text-center">Set Quantity</p>
                            <div className="flex justify-center items-center">
                                <img src="/images/Group8502.png" alt="icon" className={`${quantity > 1 ? 'cursor-pointer' : 'pointer-events-none'}`} style={{ width: '36px' }} onClick={() => handleQuantity('-', quantity)} />
                                <input
                                    value={quantity}
                                    type="text"
                                    pattern="\d.*"
                                    onKeyDown={(e) => ['ArrowUp', 'ArrowDown'].includes(e.key) && e.preventDefault()}
                                    onChange={(e) => {
                                        setquantity(e.target.value);
                                        handleCheck(e.target.value);
                                    }}
                                    maxLength="11"
                                    className="sm:w-[110px] w-13 h-7 border border-[#808285] rounded-lg outline-0 text-center sm:px-2 px-1 sm:text-xs9 text-xs6 font-semibold text-[#090406] mx-2"
                                />
                                <p className="text-base font-semibold text-[#090406] self-end mr-2">{prod?.PRIMARY_UOM_CODE}</p>
                                <img src="/images/Group8503.png" alt="icon" className="cursor-pointer" style={{ width: '36px' }} onClick={() => handleQuantity('+', quantity)} />
                            </div>
                            {quantityError && (
                                <p className="text-xs3 font-normal text-[#ED1C24] pt-2 flex justify-center items-center">
                                    <span>
                                        <img src="/images/info_icon.svg" alt="icon" className="cursor-pointer pr-1" />
                                    </span>
                                    Quantity should be based on the MOQ and Standard Pack Size
                                </p>
                            )}
                        </div>
                        <div className="flex items-center justify-between">
                            <div className="ml-2.5">
                                <p className="text-xs3 font-semibold mb-2 text-[#808285]">Discount</p>
                                <div className="flex">
                                    <ul className="nav nav-pills flex border border-[#555259] rounded-[5px]" id="pills-tabVertical" role="tablist">
                                        <li onClick={() => handleTypeToggle('₹')} className="nav-item flex-grow text-center ml-[-1px]" role="presentation">
                                            <a href="javascript:void(0)" className={`nav-link block ${TypeToggle === '₹' ? 'active' : ''} offer-currency font-semibold text-[#555259] text-xs19 w-[30px] rounded-[5px]`} id="pill1" data-bs-toggle="pill" data-bs-target="#home1" role="tab" aria-controls="home1" aria-selected="true">
                                                ₹
                                            </a>
                                        </li>
                                        <li onClick={() => handleTypeToggle('%')} className="nav-item flex-grow text-center mr-[-1px]" role="presentation">
                                            <a href="javascript:void(0)" className={`nav-link block offer-currency ${TypeToggle === '%' ? 'active' : ''} font-bold text-[#555259] text-xs19 w-[30px] rounded-[5px]`} id="pill2" data-bs-toggle="pill" data-bs-target="#home2" role="tab" aria-controls="home2" aria-selected="true">
                                                %
                                            </a>
                                        </li>
                                    </ul>
                                    <div className="tab-content" id="pills-tabContentVertical">
                                        <div
                                            className="tab-pane fade  active"
                                            id="home1"
                                            role="tabpanel"
                                            aria-labelledby="pill1"
                                        >
                                            <input
                                                minLength={1}
                                                onScroll={(e) => e.preventDefault()}
                                                onWheel={(e) => e.target.blur()}
                                                type="number"
                                                value={discount}
                                                onKeyDown={(e) => ['ArrowUp', 'ArrowDown'].includes(e.key) && e.preventDefault()}
                                                className="ml-2 w-[120px] h-7 border border-[#808285] rounded-lg outline-0 sm:text-xs9 text-xs6 font-semibold text-[#090406] text-right"
                                                onChange={(e) => {
                                                    if (Number(e.target.value) > -1 && (TypeToggle === '%' && Number(e.target.value) < 100) || (TypeToggle === '₹' && Number(e.target.value) < Number(prod.sub_total))) {
                                                        if ((TypeToggle === '%' && e.target.value.match(/^(\d*\.{0,1}\d{0,2}$)/)) || TypeToggle === '₹') {
                                                            setdiscount(e.target.value);
                                                            handlePrice(e.target.value, TypeToggle);
                                                        }
                                                    } else {
                                                        setdiscount(0);
                                                        handlePrice(0, TypeToggle);
                                                    }
                                                    if (e.target.value === '') {
                                                        setdiscount(0);
                                                        handlePrice(0, TypeToggle);
                                                    }
                                                }}
                                            />
                                        </div>

                                    </div>
                                </div>
                                <span className={`text-[#E29300] text-center maximum-discount-msg text-sm41  font-semibold ${prod?.max_discount_error && OrderDetails?.order_type === 'Domestic' ? '' : 'hidden'}`}> Maximum Discount Exceeded</span>
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center w-full justify-between">
                        <div className="w-full mt-4 bg-[#F5F5FA] rounded-lg text-center py-1.5">
                            <p className="text-xs2 font-semibold text-[#808285]">Sub Total</p>
                            <div className="flex justify-center items-center pl-1">
                                <p className="md:text-xs4 text-base font-semibold text-[#15090E] mr-1 sm:pt-0.5">{PriceHandler(Number((prod?.LIST_PRICE || 1)) * Number(quantity))}</p>
                                <span>
                                    <button
                                        className="mt-2"
                                        data-tooltip-target="tooltip-discountPercentage"
                                        data-tooltip-placement="right"
                                        data-tooltip-trigger="click"
                                        type="button"
                                        onMouseEnter={() => {
                                            setSubTotalPricehoverId(prod.INVENTORY_ITEM_ID);
                                        }}
                                        onMouseLeave={() => {
                                            setSubTotalPricehoverId('');
                                        }}
                                    >
                                        <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer w-[14px] h-[14px]" />
                                    </button>
                                    {
                                        subTotalPricehoverId === prod.INVENTORY_ITEM_ID && (
                                            <ItemPriceTooltip
                                                hover={subTotalPricehoverId === prod.INVENTORY_ITEM_ID}
                                                prod={prod}
                                                itemPriceValue={(Number((prod?.LIST_PRICE)) * Number(quantity)) / prod?.quantity}
                                                onMouseEnter={() => {
                                                    setSubTotalPricehoverId(prod.INVENTORY_ITEM_ID);
                                                }}
                                                onMouseLeave={() => {
                                                    setSubTotalPricehoverId('');
                                                }}
                                            />
                                        )
                                    }
                                    <ItemPriceTooltip prod={prod} itemPriceValue={(Number((prod?.LIST_PRICE)) * Number(quantity)) / prod?.quantity} />
                                </span>
                            </div>
                        </div>
                        <div className="w-full mt-4 bg-[#F5F5FA] rounded-lg text-center py-1.5 ml-[5px]">
                            <p className="text-xs2 font-semibold text-[#808285]">Total Price</p>
                            <div className="flex justify-center items-center pl-1">
                                <p className="md:text-xs4 text-base font-semibold text-[#15090E] mr-1 sm:pt-0.5">{PriceHandler(prod?.total_price)}</p>
                                <span>
                                    <button
                                        className="mt-2"
                                        data-tooltip-target="tooltip-discountPercentage"
                                        data-tooltip-placement="right"
                                        data-tooltip-trigger="click"
                                        type="button"
                                        onMouseEnter={() => {
                                            setTotalitemPricehoverId(prod.INVENTORY_ITEM_ID);
                                        }}
                                        onMouseLeave={() => {
                                            setTotalitemPricehoverId('');
                                        }}
                                    >
                                        <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer w-[14px] h-[14px]" />
                                    </button>
                                    {
                                        totalPricehoverId === prod.INVENTORY_ITEM_ID && (
                                            <ItemPriceTooltip
                                                hover={totalPricehoverId === prod.INVENTORY_ITEM_ID}
                                                prod={prod}
                                                itemPriceValue={Number(prod?.total_price) / prod?.quantity}
                                                netDiscount={totalPriceNetDiscount}
                                                onMouseEnter={() => {
                                                    setTotalitemPricehoverId(prod.INVENTORY_ITEM_ID);
                                                }}
                                                onMouseLeave={() => {
                                                    setTotalitemPricehoverId('');
                                                }}
                                            />
                                        )
                                    }
                                    <ItemPriceTooltip prod={prod} itemPriceValue={Number(prod?.total_price) / prod?.quantity} netDiscount={totalPriceNetDiscount} />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="border-b flex items-center justify-start py-2 border-[#CBCBCB]">
                    <img src="/images/unioin-icon.svg" alt="" />
                    <span className="text-xs3 ml-1 text-[#808285]">Quantity is based on the MOQ and Standard Pack Size</span>
                </div>
            </div>
            <div className="lg:pl-4 xl:pr-9 px-0">
                <div className="flex justify-center items-end flex-col">
                    <div className="flex justify-end pt-3">
                        <label>
                            <Toggle
                                checked={isOn}
                                icons={false}
                                onChange={toggleSwitch}
                            />
                        </label>
                        <p style={{ fontSize: '13px' }} className="ml-2 color-[#090406]">Use same address for all products</p>
                    </div>
                </div>
                <div className="flex -mx-6 mt-2">
                    <div className="px-6 lg:w-1/2 w-full">
                        <p className="mb-1.5 text-xs13 font-semibold text-[#808285]">Billing address</p>
                        <div className="dropdown relative">
                            <button
                                type="button"
                                onClick={() => handleToggle('billing_address')}
                                id={groupIdx + itemIndex}
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                className="dropdown-to h-fit flex items-center w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5"
                            >
                                <AddressSelection selectedAddressObj={prod.BILLING_ADDRESS} index={0} type="billing_address" selection={false} />
                                <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-1/2 right-5" />
                            </button>
                            <ul className={`dropdown-menu w-full absolute ${addressType.billing_address ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 py-3 overflow-auto pl-2 pr-3.5 max-h-[300px] scrollbar-menu z-10`} aria-labelledby={groupIdx + itemIndex}>
                                <input onChange={(e) => setsearchKey(e.target.value)} className="w-full border  h-8 p-3" placeholder="search address..." />
                                {Object.keys(addressDropdown).length > 0 && addressDropdown.billing_address.filter((val) => handleSearch(val)).map((item, addressIndex) => (
                                    <li className="w-full bg-[#ffffff] hover:bg-[#F5F5FA] rounded-md pl-1 py-1">
                                        <div className="relative checkbox custom-checkbox custom-radio3 flex items-center dropdown-item">
                                            <input type="radio" id={`${`checkbox-address-${itemIndex}-billing_address-${addressIndex + 1}`}`} name="radiodate" className="cursor-pointer" />
                                            <AddressSelection selectedAddressObj={item} index={addressIndex + 1} type="billing_address" selection />
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    {/* <!-- shiffing address --> */}
                    <div className="px-6 lg:w-1/2 w-full lg:mt-0 mt-3">
                        <p className="mb-1.5 text-xs13 font-semibold text-[#808285]">Shipping address</p>
                        <div className="dropdown relative">
                            <button
                                type="button"
                                onClick={() => handleToggle('shipping_address')}
                                id="s1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                className="dropdown-to h-fit w-full flex items-center rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5"
                            >
                                <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-1/2 right-5" />
                                <AddressSelection selectedAddressObj={prod.SHIPPING_ADDRESS} index={0} type="shipping_address" selection={false} />
                            </button>
                            <ul className={`dropdown-menu w-full absolute ${addressType.shipping_address ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 py-3 overflow-auto pl-2 pr-3.5 max-h-[300px] scrollbar-menu z-10`} aria-labelledby="s1">
                                <input onChange={(e) => setsearchKey(e.target.value)} className="w-full border  h-8 p-3" placeholder="search address..." />
                                {Object.keys(addressDropdown).length > 0 && addressDropdown.shipping_address.filter((val) => handleSearch(val)).map((item, addressIndex) => (
                                    <li className="w-full bg-[#ffffff] hover:bg-[#F5F5FA] rounded-md pl-1 py-1">
                                        <div className="relative checkbox custom-checkbox custom-radio3 flex items-center dropdown-item">
                                            <input type="radio" id={`${`checkbox-address-${itemIndex}-shipping_address-${addressIndex + 1}`}`} name="radiodate" className="cursor-pointer" />
                                            <AddressSelection selectedAddressObj={item} index={addressIndex + 1} type="shipping_address" selection />
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <button
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#removefromWishes"
                onClick={() => setDeleteModal(true)}
            >
                <img src="/images/Icon-feather-trash-2.svg" alt="icon" className="absolute top-[17px] right-[22px] cursor-pointer" />
            </button>
            {deleteModal && <DeleteProductsModal deleteModal={deleteModal} setDeleteModal={setDeleteModal} handleDeleteProduct={handleDeleteProduct} />}
        </div>
    );
}
